/**
 * Google OAuth 開始 URL。
 * 開発時は CRA proxy 経由だと 302 が正しく辿れないことがあるため API サーバーへ直結する。
 */
export function getGoogleAuthStartUrl() {
  if (process.env.REACT_APP_GOOGLE_AUTH_START_URL) {
    return process.env.REACT_APP_GOOGLE_AUTH_START_URL;
  }

  const apiBase = process.env.REACT_APP_API_BASE_URL || '';
  if (apiBase.startsWith('http://') || apiBase.startsWith('https://')) {
    const normalized = apiBase.replace(/\/$/, '');
    return `${normalized}/auth/google`;
  }

  if (process.env.NODE_ENV === 'development') {
    return 'http://localhost:5001/api/auth/google';
  }

  return '/api/auth/google';
}
